import type { ProductVariantType } from '../../model/types/productCard';

import { FC } from 'react';

import Link from 'next/link';

import { useProductVariant } from '../../hooks/useProductVariant';
import { Slider } from '../Slider/Slider';
import { Controls } from './Controls/Controls';
import { Info } from './Info/Info';
import cls from './RowVariant.module.scss';

export const RowVariant: FC<ProductVariantType> = ({ data }) => {
  const { hover, url, mouseOnHaler, mouseLeaveHandler } = useProductVariant(data);

  const images = data.images?.slice(0, 4);

  return (
    <div
      onMouseLeave={mouseLeaveHandler}
      onMouseOver={mouseOnHaler}
      className={cls.wrap}
    >
      <Link
        aria-label={`Перейти на страницу товара ${data.name}`}
        className={cls.link}
        href={url}
      >
        {images && images.length > 0 ? (
          <Slider
            variant={'row'}
            className={cls.slider}
            slides={images}
            hovered={hover}
            productName={data.name}
            advantages={data.advantages}
          />
        ) : (
          <div className={cls.empty}>нет фото</div>
        )}
        <Info data={data} />
      </Link>

      <Controls
        {...{ ...data, url }}
        selected={false}
        quantity={1}
      />
    </div>
  );
};
